import React from 'react';
import PropTypes from 'prop-types';

const ValidationMessage = ({ controlName, message }) => (
    <div className="rec-required">
        <p className="rec-required-msg">
            <mark>*</mark> <strong>{controlName}</strong> {message}
        </p>
    </div>
);

ValidationMessage.propTypes = {
    controlName: PropTypes.string.isRequired,
    message: PropTypes.node.isRequired
};

ValidationMessage.defaultProps = {
    controlName: '',
    message: null
};

export default ValidationMessage;
